// modSelectors.js

export const selectLevelData = (state) => state.training.availableLevels;
export const selectAllTrainingsData = (state) => state.training.allTrainings;
export const selectLoading = (state) => state.training.loading;
